// Module
var code = "<template> <require from=\"app/cd/components/member/member-providers-grid\"></require> <member-providers-grid member-id.bind=\"memberId\" readonly.bind=\"false\" configurable.bind=\"false\"></member-providers-grid> </template> ";
// Exports
module.exports = code;